import CtaBanner from 'src/sections/CtaBanner/CtaBanner';
import { Stack } from 'src/components-v2/Layout';
import RichTextSwitch from 'src/containers/RichTextSwitch/RichTextSwitch';
import { Btn as Button } from 'src/components-v2/Inputs';
import { CmsThemes, targetMap } from 'src/lib/constants';
import { useCmsTheme } from 'src/contexts/CmsThemeContext/CmsThemeContextProvider';

export const CmsCtaHeaderBanner = ({ fields, sys }) => {
  const bgColor = fields?.backgroundColor?.toLowerCase() || 'white';
  const bgImage = fields?.backgroundImage?.fields?.file?.url;
  const cmsTheme = useCmsTheme();
  const isV2 = cmsTheme === CmsThemes.WEB2;

  return (
    <CtaBanner
      sx={{
        ...fields?.styles,
      }}
      sys={sys}
      bgImage={bgImage}
      mode={fields?.mode}
      intrinsicMode={fields?.intrinsicMode || fields?.mode}
      backgroundColor={bgColor}
    >
      <Stack
        direction='column'
        gap={{ xs: 2, lg: 3 }}
        sx={{
          '& p:nth-last-of-type(1):empty': {
            display: 'none',
          },
        }}
      >
        <RichTextSwitch
          sys={sys}
          content={
            // TODO: remove this condition once migration is complete
            fields?.body?.content?.length ? fields?.body : fields?.headerBody
          }
          nodes={{
            h2: {
              variant: 'h2',
              component: 'h2',
              fieldId: 'headerBody',
            },
            h3: {
              variant: 'h3',
              component: 'h2',
              fieldId: 'headerBody',
            },
            h4: {
              variant: 'h4',
              component: 'h2',
              fieldId: 'headerBody',
            },
            h6: {
              variant: 'h6',
              component: 'span',
              fieldId: 'headerBody',
            },
            p: {
              variant: 'p',
              component: 'p',
              fieldId: 'headerBody',
              sx: {
                ...(isV2 && {
                  color: (theme) => {
                    return theme.palette[
                      bgImage ? 'base/black/800' : 'base/black/200'
                    ];
                  },
                }),
              },
            },
          }}
        />
      </Stack>
      {fields?.cta?.fields?.text && (
        <Button
          variant={'primary'}
          trackingId={fields?.cta?.fields?.trackingId || ''}
          sys={fields?.cta?.sys}
          sx={{
            mt: { xs: '16px', md: '8px', lg: '0' },
            width: { xs: '100%', sm: 'auto' },
            flexShrink: 0,
          }}
          {...(fields?.cta?.fields?.target === 'Modal'
            ? {
                onClick: () => {
                  return null; // SITE-5615 removed gold cast modal method
                },
              }
            : {
                href: fields?.cta?.fields?.url,
                target: targetMap[fields?.cta?.fields?.target] || '_self',
              })}
        >
          {fields?.cta?.fields?.text}
        </Button>
      )}
    </CtaBanner>
  );
};
